import { BoExternalIdentityI } from '@Utils/providers/authProvider';

export const identityTranslations = {
  fields: {
    id: 'Admin ID',
    email: 'Email',
    fullName: 'Full name',
    companyId: 'Company ID',
    phone_number: 'Phone number',
    roles: 'Roles',
    role_definitions: 'Role definitions',
    auth_role: 'Role for the user',
    contract_availability: 'Contract availability',
    companies: 'Companies',
  } satisfies Record<keyof BoExternalIdentityI, string>,
};
